import { get, httpDelete, patch, post } from "@readai/common/api";
import type {
  ApiCustomVocabulary,
  CustomVocabulary,
  PatchCustomVocabularyBody,
  PostCustomVocabularyBody,
} from "@readai/common/types/customVocabularyTypes";
import { parseUTCDateTimeFromString } from "@readai/common/utils/datetimeUtils";

const parseCustomVocabularyResponse = (
  apiData: ApiCustomVocabulary[],
): CustomVocabulary[] => {
  return (apiData ?? []).map((word) => ({
    ...word,
    createdOn: parseUTCDateTimeFromString(word.createdOn),
  }));
};

export const createCustomVocabulary = async (
  body: PostCustomVocabularyBody,
): Promise<void> => {
  return post("/custom-vocabulary", body, { withCreds: true });
};

export const listCustomVocabulary = async () => {
  const response: ApiCustomVocabulary[] = await get("/custom-vocabulary", {
    withCreds: true,
  });
  return parseCustomVocabularyResponse(response);
};

export const patchCustomVocabulary = async (
  body: PatchCustomVocabularyBody,
): Promise<void> => {
  return patch(`/custom-vocabulary/${body.id}`, body, { withCreds: true });
};

export const deleteCustomVocabulary = async (
  id: CustomVocabulary["id"],
): Promise<void> => {
  return httpDelete(`/custom-vocabulary/${id}`, { withCreds: true });
};
